import { render, staticRenderFns } from "./addHost.vue?vue&type=template&id=3f9ed73f&"
import script from "./addHost.vue?vue&type=script&lang=js&"
export * from "./addHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f9ed73f')) {
      api.createRecord('3f9ed73f', component.options)
    } else {
      api.reload('3f9ed73f', component.options)
    }
    module.hot.accept("./addHost.vue?vue&type=template&id=3f9ed73f&", function () {
      api.rerender('3f9ed73f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/liveData/components/addHost.vue"
export default component.exports